import React from 'react';

import styles from './Container.module.scss';

function Container({ children }: React.PropsWithChildren<any>): JSX.Element {
  return <div className={styles.wrapper}>{children}</div>;
}

export default Container;
